import { websiteLinks } from '@/shared/config/links'
import { appStorage } from '@/utils/storage/app'
import { logger } from '@/utils/logger'
import i18n from '@/i18n'
import { notifyWarning } from '@/utils/error'

// Must be an absolute marketing-site URL. Relative `/` on app.easyhireai.com
// redirects back into the SPA (`/` → `/manage` → login) and creates an auth loop.
export const OFFICIAL_SITE_PATH = `${websiteLinks.officialWebsite}/`

export type AuthRedirectReason =
  | 'signInInitFailed'
  | 'restoreAuthFailed'
  | 'missingAuthState'
  | 'callbackFailed'
  | 'callbackSdkError'
  | 'callbackTimeout'
  | 'apiUnauthorized'
  | 'logtoUnauthorized'

const reasonMessageKeyMap: Record<AuthRedirectReason, string> = {
  signInInitFailed: 'auth.redirectReasons.signInInitFailed',
  restoreAuthFailed: 'auth.redirectReasons.restoreAuthFailed',
  missingAuthState: 'auth.redirectReasons.missingAuthState',
  callbackFailed: 'auth.redirectReasons.callbackFailed',
  callbackSdkError: 'auth.redirectReasons.callbackSdkError',
  callbackTimeout: 'auth.redirectReasons.callbackTimeout',
  apiUnauthorized: 'auth.redirectReasons.apiUnauthorized',
  logtoUnauthorized: 'auth.redirectReasons.logtoUnauthorized',
}

export const redirectToOfficialSite = (reason?: AuthRedirectReason) => {
  appStorage.clearPostLoginRedirect()
  if (reason) {
    logger.warn(`Redirecting to official site after auth failure: ${reason}`)
    notifyWarning(i18n.global.t(reasonMessageKeyMap[reason]))
  } else {
    notifyWarning(i18n.global.t('auth.redirectToOfficialSite'))
  }
  window.location.replace(OFFICIAL_SITE_PATH)
}
